// Точки на сцене подсвечивают карточку товара; добавление в корзину без перезагрузки.
class ShopTheLook extends HTMLElement {
  connectedCallback() {
    this.dots = Array.from(this.querySelectorAll('.shop-the-look__dot'));
    this.cards = Array.from(this.querySelectorAll('.shop-the-look__card'));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.select(dot.dataset.index));
      dot.addEventListener('mouseenter', () => this.select(dot.dataset.index));
    });

    this.cards.forEach((card) => {
      card.addEventListener('mouseenter', () => this.select(card.dataset.index));
    });

    this.querySelectorAll('.shop-the-look__form').forEach((form) => {
      form.addEventListener('submit', (event) => this.addToCart(event, form));
    });

    if (this.dots.length) this.select(this.dots[0].dataset.index);
  }

  select(index) {
    this.dots.forEach((dot) => dot.classList.toggle('is-active', dot.dataset.index === index));
    this.cards.forEach((card) => card.classList.toggle('is-active', card.dataset.index === index));
  }

  addToCart(event, form) {
    event.preventDefault();
    const button = form.querySelector('button');
    button.setAttribute('disabled', 'disabled');
    button.classList.add('loading');

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer
      ? ['cart-drawer', 'cart-icon-bubble']
      : ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];

    const body = new FormData(form);
    body.append('sections', sections.join(','));
    body.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body,
    })
      .then((response) => response.json())
      .then((parsed) => {
        if (parsed.sections && cartDrawer) {
          cartDrawer.renderContents(parsed);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        } else {
          window.location.href = window.routes.cart_url;
        }
      })
      .catch(() => {
        window.location.href = window.routes.cart_url;
      })
      .finally(() => {
        button.removeAttribute('disabled');
        button.classList.remove('loading');
      });
  }
}

if (!customElements.get('shop-the-look')) customElements.define('shop-the-look', ShopTheLook);
